import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { SimpleTable } from "../common/SimpleTable";
import { useMst } from "../../mobx";
import { SimpleTableColumns } from "../common/SimpleTable/SimpleTable";
import { useHistory, useLocation } from "react-router-dom";
import { parse, stringify } from "query-string";
import { PageQuery } from "../../api/questions/typings";

export default observer(function SkillsTable() {
    const [loading, setLoading] = useState(false);
    const { skillsStore } = useMst();
    const { getSkills, getSkillsTableData } = skillsStore;
    const { total } = skillsStore.page;
    const location = useLocation();
    const history = useHistory();
    const params = parse(location.search) as PageQuery;
    const page = params["page[number]"];
    const size = params["page[size]"];

    useEffect(() => {
        if (!page || !size) {
            history.push({
                search: stringify({
                    "page[size]": "15",
                    "page[number]": "1",
                }),
            })
        } else {
            getTopicsAsync();
        }

        async function getTopicsAsync() {
            setLoading(true);
            await getSkills({
                "page[size]": size,
                "page[number]": page,
            });
            setLoading(false);
        }
    }, [page, size]);

    const columns: SimpleTableColumns[] = [
        {
            field: 'id',
            headerName: 'ID'

        },
        {
            field: 'title',
            headerName: 'Заголовок',
        },
        {
            field: 'order',
            headerName: 'Порядок',
            align: "right",
        }
    ]

    return (
        <div style={{ width: "100%" }}>
            <SimpleTable
                columns={columns}
                rows={getSkillsTableData}
                loading={loading}
                page={page ? parseFloat(page) - 1 : undefined}
                rowsPerPage={size ? parseFloat(size) : undefined}
                count={total}
                onPageChange={(_, page) =>
                    history.push({
                        search: stringify({
                            "page[size]": size,
                            "page[number]": (page + 1).toString(),
                        }),
                    })
                }
            />
        </div>
    )
})